'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_IO = require("../Relude_IO.bs.js");
var Relude_Int = require("../Relude_Int.bs.js");
var Int$BsBastet = require("bs-bastet/bastet/src/Int.bs.js");
var Relude_Float = require("../Relude_Float.bs.js");
var Relude_Result = require("../Relude_Result.bs.js");
var Relude_String = require("../Relude_String.bs.js");
var Array$BsBastet = require("bs-bastet/bastet/src/Array.bs.js");
var Float$BsBastet = require("bs-bastet/bastet/src/Float.bs.js");
var Relude_NonEmpty = require("../Relude_NonEmpty.bs.js");
var Relude_Array_Base = require("./Relude_Array_Base.bs.js");
var Relude_Validation = require("../Relude_Validation.bs.js");
var Relude_Array_Instances = require("./Relude_Array_Instances.bs.js");
var Relude_Option_Instances = require("../option/Relude_Option_Instances.bs.js");

function ArrayEqExtensions(E) {
  var include = Curry._1(Relude_Array_Instances.FoldableEqExtensions, E);
  var distinct = function (param) {
    return Relude_Array_Base.distinctBy(E.eq, param);
  };
  var removeFirst = function (param, param$1) {
    return Relude_Array_Base.removeFirstBy(E.eq, param, param$1);
  };
  var removeEach = function (param, param$1) {
    return Relude_Array_Base.removeEachBy(E.eq, param, param$1);
  };
  var eq = function (param, param$1) {
    return Relude_Array_Instances.eqBy(E.eq, param, param$1);
  };
  return {
          contains: include.contains,
          indexOf: include.indexOf,
          distinct: distinct,
          removeFirst: removeFirst,
          removeEach: removeEach,
          eq: eq
        };
}

function ArrayOrdExtensions(O) {
  var include = Curry._1(Relude_Array_Instances.FoldableEqExtensions, O);
  var distinct = function (param) {
    return Relude_Array_Base.distinctBy(O.eq, param);
  };
  var removeFirst = function (param, param$1) {
    return Relude_Array_Base.removeFirstBy(O.eq, param, param$1);
  };
  var removeEach = function (param, param$1) {
    return Relude_Array_Base.removeEachBy(O.eq, param, param$1);
  };
  var eq = function (param, param$1) {
    return Relude_Array_Instances.eqBy(O.eq, param, param$1);
  };
  var include$1 = Curry._1(Relude_Array_Instances.FoldableOrdExtensions, O);
  var sort = function (param) {
    return Relude_Array_Base.sortBy(O.compare, param);
  };
  return {
          contains: include.contains,
          indexOf: include.indexOf,
          distinct: distinct,
          removeFirst: removeFirst,
          removeEach: removeEach,
          eq: eq,
          min: include$1.min,
          max: include$1.max,
          sort: sort
        };
}

function ArrayMonoidExtensions(M) {
  return Curry._1(Relude_Array_Instances.FoldableMonoidExtensions, M);
}

var include = Curry._1(Relude_Array_Instances.FoldableEqExtensions, Relude_String.Ord);

function removeFirst(param, param$1) {
  return Relude_Array_Base.removeFirstBy(Relude_String.Ord.eq, param, param$1);
}

function removeEach(param, param$1) {
  return Relude_Array_Base.removeEachBy(Relude_String.Ord.eq, param, param$1);
}

function eq(param, param$1) {
  return Relude_Array_Instances.eqBy(Relude_String.Ord.eq, param, param$1);
}

var include$1 = Curry._1(Relude_Array_Instances.FoldableOrdExtensions, Relude_String.Ord);

function sort(param) {
  return Relude_Array_Base.sortBy(Relude_String.Ord.compare, param);
}

var include$2 = Curry._1(Relude_Array_Instances.FoldableMonoidExtensions, Relude_String.Monoid);

var foldWithMonoid = include$2.foldWithMonoid;

var intercalate = include$2.intercalate;

function distinct(xs) {
  return Object.keys(Curry._3(Relude_Array_Instances.foldLeft, (function (acc, curr) {
                    acc[curr] = 0;
                    return acc;
                  }), {}, xs));
}

var String_contains = include.contains;

var String_indexOf = include.indexOf;

var String_min = include$1.min;

var String_max = include$1.max;

var String_BsFoldableMonoidExtensions = include$2.BsFoldableMonoidExtensions;

var String_foldMap = include$2.foldMap;

var $$String = {
  contains: String_contains,
  indexOf: String_indexOf,
  removeFirst: removeFirst,
  removeEach: removeEach,
  eq: eq,
  min: String_min,
  max: String_max,
  sort: sort,
  BsFoldableMonoidExtensions: String_BsFoldableMonoidExtensions,
  foldMap: String_foldMap,
  foldWithMonoid: foldWithMonoid,
  intercalate: intercalate,
  join: foldWithMonoid,
  joinWith: intercalate,
  distinct: distinct
};

var include$3 = Curry._1(Relude_Array_Instances.FoldableEqExtensions, Relude_Int.Ord);

function distinct$1(param) {
  return Relude_Array_Base.distinctBy(Relude_Int.Ord.eq, param);
}

function removeFirst$1(param, param$1) {
  return Relude_Array_Base.removeFirstBy(Relude_Int.Ord.eq, param, param$1);
}

function removeEach$1(param, param$1) {
  return Relude_Array_Base.removeEachBy(Relude_Int.Ord.eq, param, param$1);
}

function eq$1(param, param$1) {
  return Relude_Array_Instances.eqBy(Relude_Int.Ord.eq, param, param$1);
}

var include$4 = Curry._1(Relude_Array_Instances.FoldableOrdExtensions, Relude_Int.Ord);

function sort$1(param) {
  return Relude_Array_Base.sortBy(Relude_Int.Ord.compare, param);
}

var sum = Curry._1(Relude_Array_Instances.foldWithMonoid, Int$BsBastet.Additive.Monoid);

var product = Curry._1(Relude_Array_Instances.foldWithMonoid, Int$BsBastet.Multiplicative.Monoid);

var Int_contains = include$3.contains;

var Int_indexOf = include$3.indexOf;

var Int_min = include$4.min;

var Int_max = include$4.max;

var Int = {
  contains: Int_contains,
  indexOf: Int_indexOf,
  distinct: distinct$1,
  removeFirst: removeFirst$1,
  removeEach: removeEach$1,
  eq: eq$1,
  min: Int_min,
  max: Int_max,
  sort: sort$1,
  sum: sum,
  product: product
};

var include$5 = Curry._1(Relude_Array_Instances.FoldableEqExtensions, Relude_Float.Ord);

function distinct$2(param) {
  return Relude_Array_Base.distinctBy(Relude_Float.Ord.eq, param);
}

function removeFirst$2(param, param$1) {
  return Relude_Array_Base.removeFirstBy(Relude_Float.Ord.eq, param, param$1);
}

function removeEach$2(param, param$1) {
  return Relude_Array_Base.removeEachBy(Relude_Float.Ord.eq, param, param$1);
}

function eq$2(param, param$1) {
  return Relude_Array_Instances.eqBy(Relude_Float.Ord.eq, param, param$1);
}

var include$6 = Curry._1(Relude_Array_Instances.FoldableOrdExtensions, Relude_Float.Ord);

function sort$2(param) {
  return Relude_Array_Base.sortBy(Relude_Float.Ord.compare, param);
}

var sum$1 = Curry._1(Relude_Array_Instances.foldWithMonoid, Float$BsBastet.Additive.Monoid);

var product$1 = Curry._1(Relude_Array_Instances.foldWithMonoid, Float$BsBastet.Multiplicative.Monoid);

var Float_contains = include$5.contains;

var Float_indexOf = include$5.indexOf;

var Float_min = include$6.min;

var Float_max = include$6.max;

var Float = {
  contains: Float_contains,
  indexOf: Float_indexOf,
  distinct: distinct$2,
  removeFirst: removeFirst$2,
  removeEach: removeEach$2,
  eq: eq$2,
  min: Float_min,
  max: Float_max,
  sort: sort$2,
  sum: sum$1,
  product: product$1
};

var include$7 = Curry._1(Array$BsBastet.Traversable, Relude_Option_Instances.Applicative);

var $$Option = include$7;

function traverse(f, xs) {
  var ResultE = Relude_Result.WithError({});
  var TraverseResult = Curry._1(Array$BsBastet.Traversable, ResultE.Applicative);
  return Curry._2(TraverseResult.traverse, f, xs);
}

function sequence(xs) {
  var ResultE = Relude_Result.WithError({});
  var TraverseResult = Curry._1(Array$BsBastet.Traversable, ResultE.Applicative);
  return Curry._1(TraverseResult.sequence, xs);
}

var Result = {
  traverse: traverse,
  sequence: sequence
};

function traverse$1(f, xs) {
  var IoE = Relude_IO.WithError({});
  var TraverseIO = Curry._1(Array$BsBastet.Traversable, IoE.Applicative);
  return Curry._2(TraverseIO.traverse, f, xs);
}

function sequence$1(xs) {
  var IoE = Relude_IO.WithError({});
  var TraverseIO = Curry._1(Array$BsBastet.Traversable, IoE.Applicative);
  return Curry._1(TraverseIO.sequence, xs);
}

var IO = {
  traverse: traverse$1,
  sequence: sequence$1
};

function WithErrors(Errors, $$Error) {
  var ValidationE = Relude_Validation.WithErrors(Errors, $$Error);
  var Traversable = Curry._1(Array$BsBastet.Traversable, ValidationE.Applicative);
  return {
          ValidationE: ValidationE,
          Traversable: Traversable
        };
}

function WithErrorsAsArray($$Error) {
  var ValidationE = Relude_Validation.WithErrors(Relude_Array_Instances.SemigroupAny, $$Error);
  var Traversable = Curry._1(Array$BsBastet.Traversable, ValidationE.Applicative);
  return {
          ValidationE: ValidationE,
          Traversable: Traversable
        };
}

var $$Error = {};

var ValidationE = Relude_Validation.WithErrors(Relude_Array_Instances.SemigroupAny, $$Error);

var Traversable = Curry._1(Array$BsBastet.Traversable, ValidationE.Applicative);

var WithErrorsAsArrayOfStrings = {
  ValidationE: ValidationE,
  Traversable: Traversable
};

function WithErrorsAsNonEmptyArray($$Error) {
  var ValidationE = Relude_Validation.WithErrors(Relude_NonEmpty.$$Array.SemigroupAny, $$Error);
  var Traversable = Curry._1(Array$BsBastet.Traversable, ValidationE.Applicative);
  return {
          ValidationE: ValidationE,
          Traversable: Traversable
        };
}

function traverse$2(f, array) {
  var $$Error = {};
  var ValidationE = Relude_Validation.WithErrors(Relude_NonEmpty.$$Array.SemigroupAny, $$Error);
  var Traversable = Curry._1(Array$BsBastet.Traversable, ValidationE.Applicative);
  return Curry._2(Traversable.traverse, (function (a) {
                return Relude_Result.toValidationNea(Curry._1(f, a));
              }), array);
}

var Validation = {
  WithErrors: WithErrors,
  WithErrorsAsArray: WithErrorsAsArray,
  WithErrorsAsArrayOfStrings: WithErrorsAsArrayOfStrings,
  WithErrorsAsNonEmptyArray: WithErrorsAsNonEmptyArray,
  traverse: traverse$2
};

exports.ArrayEqExtensions = ArrayEqExtensions;
exports.ArrayOrdExtensions = ArrayOrdExtensions;
exports.ArrayMonoidExtensions = ArrayMonoidExtensions;
exports.$$String = $$String;
exports.Int = Int;
exports.Float = Float;
exports.$$Option = $$Option;
exports.Result = Result;
exports.IO = IO;
exports.Validation = Validation;
/* include Not a pure module */
